import { useContainer } from '@hub-la/fe-container';
import { HttpClient } from '@hub-la/fe-core-http-client';
import { useMutation } from 'react-query';
import { GetAssetsSignedUrl } from '../../usecases/get-assets-signed-url.js';

const useGetAssetsSignedUrl = () => {
  const container = useContainer();
  return useMutation([], input => {
    return new GetAssetsSignedUrl(container.get(HttpClient)).execute(input);
  });
};

export { useGetAssetsSignedUrl };
